"use strict";

exports.__esModule = true;
exports.useWidth = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var useWidth = exports.useWidth = function useWidth(renderItemText, renderItemLabel, items, minWidth) {
  if (minWidth === void 0) {
    minWidth = 0;
  }
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var longestItemTextLength = Math.max.apply(Math, items.map(function (item) {
    var itemElWidth = 0;
    var text = renderItemText && renderItemText(item);
    var label = renderItemLabel && renderItemLabel(item);
    if (typeof text === "string") {
      itemElWidth = itemElWidth + text.length * theme["DropdownTextWidthFactor"];
    }
    if (typeof label === "string") {
      itemElWidth = itemElWidth + label.length * theme["DropdownLabelWidthFactor"];
    }
    return itemElWidth + 100;
  }));
  return Math.max(longestItemTextLength, minWidth);
};